import { MIN_AWARD_AMOUNT_HKD_CENTS, resolveAwardTier } from '@ark/nup-shared';
import { getCopy } from '../constants/copy';

export type ProgressStage =
  | 'idle'
  | 'enrolled'
  | '1w'
  | '15w'
  | '40w'
  | '100w'
  | '500w'
  | '1000w'
  | '2000w';

const TIER_STAGE: Record<number, ProgressStage> = {
  1_000_000: '1w',
  15_000_000: '15w',
  40_000_000: '40w',
  100_000_000: '100w',
  500_000_000: '500w',
  1_000_000_000: '1000w',
  2_000_000_000: '2000w',
};

/** 未报名用 idle；报名后按最高命中档。 */
export function resolveProgressStage(
  enrolled: boolean,
  netHkdCents: number | null | undefined,
): ProgressStage {
  if (!enrolled) {
    return 'idle';
  }
  const tier = resolveAwardTier(netHkdCents ?? 0);
  if (!tier) {
    return 'enrolled';
  }
  return TIER_STAGE[tier.minAmount] ?? 'enrolled';
}

const ADVANCED_FILL: Record<ProgressStage, number> = {
  idle: 0,
  enrolled: 0,
  '1w': 0,
  '15w': 1,
  '40w': 2,
  '100w': 3,
  '500w': 4,
  '1000w': 5,
  '2000w': 6,
};

/** 进阶赏进度点已点亮数量。1 万档仍算入门赏，不点亮进阶赏。 */
export function advancedFilledCount(
  enrolled: boolean,
  netHkdCents: number | null | undefined,
): number {
  return ADVANCED_FILL[resolveProgressStage(enrolled, netHkdCents)];
}

/** 入门赏是否已达 1 万。 */
export function hasEntryAward(
  enrolled: boolean,
  netHkdCents: number | null | undefined,
): boolean {
  return enrolled && (netHkdCents ?? 0) >= MIN_AWARD_AMOUNT_HKD_CENTS;
}

/**
 * 进度条圆点 class。
 * 未满 1 万全部灰色；满 1 万后当前档高亮；已达成档打勾。
 */
export function progressItemClass(
  index: number,
  hasReachedEntry: boolean,
  filledCount: number,
): string {
  if (index < filledCount) {
    return 'is-on is-linked';
  }
  if (hasReachedEntry && index === filledCount) {
    return 'is-active';
  }
  return '';
}

/** 已获奖副文案：最高命中档用「xx萬」/ 美元金额，不是完整净入金。 */
export function formatAwardedSub(
  netHkdCents: number | null | undefined,
  isEn = false,
): string {
  const copy = getCopy(isEn);
  const tier = resolveAwardTier(Number(netHkdCents) || 0);
  if (!tier) {
    return copy.awardedPrefixEmpty;
  }
  if (isEn) {
    const hkd = Math.round(tier.minAmount / 100);
    return copy.awardedPrefix + '$' + hkd.toLocaleString('en-US');
  }
  const wan = Math.round(tier.minAmount / MIN_AWARD_AMOUNT_HKD_CENTS);
  const wanText = wan >= 1000 ? wan.toLocaleString('en-US') : String(wan);
  return copy.awardedPrefix + '$' + wanText + '萬';
}
